import { Navigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { useStore } from "@/stores";
import { LoadingScreen } from "@/shared/ui/components";
import { AppRoutes } from "@/shared/constants";
import type { BaseComponentProps } from "@/shared/ui/base";

interface ProtectedRouteProps extends BaseComponentProps {
  children: React.ReactNode;
}

export const ProtectedRoute = observer(function ProtectedRoute({
  children,
}: ProtectedRouteProps) {
  const { authStore } = useStore();
  const { user, loading, status } = authStore;

  if (loading) {
    return <LoadingScreen />;
  }

  if (status === "not_verified") {
    return (
      <Navigate
        to={AppRoutes.login}
        replace
        state={{ error: "NOT_VERIFIED" }}
      />
    );
  }

  if (status === "needs_registration") {
    return (
      <Navigate
        to={AppRoutes.login}
        replace
        state={{ error: "NEEDS_REGISTRATION" }}
      />
    );
  }

  if (status === "forbidden") {
    return (
      <Navigate to={AppRoutes.login} replace state={{ error: "FORBIDDEN" }} />
    );
  }

  if (!user) {
    return <Navigate to={AppRoutes.login} replace />;
  }

  return <>{children}</>;
});
